var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qv3y0txv6b",
    d: "M8.889 2.217l6.693 11.564H2.196L8.889 2.217zM.658 12.892c-.685 1.182.169 2.667 1.538 2.667h13.386c1.37 0 2.222-1.485 1.538-2.667L10.427 1.328C9.742.146 8.036.146 7.35 1.328L.658 12.892zM8 6.67v1.778c0 .489.4.889.889.889s.889-.4.889-.89V6.67c0-.489-.4-.889-.89-.889-.488 0-.888.4-.888.889zm.889 4.444c.49 0 .889.398.889.89 0 .49-.398.888-.89.888-.49 0-.888-.398-.888-.889 0-.49.398-.889.889-.889z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1222 -494) translate(1222 494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qv3y0txv6b"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.26262b18.svg";
export { ForwardRef as ReactComponent };